import { Upload } from "lucide-react";
import styles from "./JobApplicationCvField.module.scss";
import { formatUserCvUpdatedAt, getCvFileNameFromUrl } from "../../../utils/userCv.ts";

const ACCEPTED_CV_TYPES = ".pdf,.doc,.docx";

export interface JobApplicationCvFieldProps {
  profileCvUrl: string | null;
  profileCvUpdatedAt?: string | null;
  cvFile: File | null;
  cvFileName: string;
  useProfileCv: boolean;
  onCvFileChange: (file: File | null, fileName: string) => void;
  onUseProfileCvChange: (use: boolean) => void;
  disabled?: boolean;
  inputId?: string;
  showProfileSaveHint?: boolean;
  filePlaceholder?: string;
}

const JobApplicationCvField: React.FC<JobApplicationCvFieldProps> = ({
  profileCvUrl,
  profileCvUpdatedAt = null,
  cvFile,
  cvFileName,
  useProfileCv,
  onCvFileChange,
  onUseProfileCvChange,
  disabled = false,
  inputId = "job-application-cv",
  showProfileSaveHint = false,
  filePlaceholder = "Seleccionar archivo (.pdf, .doc, .docx)",
}) => {
  const hasProfileCv = Boolean(profileCvUrl);
  const profileCvLabel = profileCvUrl ? getCvFileNameFromUrl(profileCvUrl) : "";
  const profileCvUpdatedLabel = formatUserCvUpdatedAt(profileCvUpdatedAt);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    onCvFileChange(file, file.name);
    onUseProfileCvChange(false);
  };

  return (
    <>
      {hasProfileCv && !cvFile ? (
        <div className={styles.savedCvBanner}>
          <p className={styles.savedCvTitle}>
            {useProfileCv
              ? `Se usará tu CV del perfil: ${profileCvLabel}`
              : "No se usará tu CV del perfil en esta postulación"}
          </p>
          {profileCvUpdatedLabel ? (
            <p className={styles.savedCvMeta}>Actualizado el {profileCvUpdatedLabel}</p>
          ) : null}
          <label className={styles.savedCvToggle}>
            <input
              type="checkbox"
              checked={useProfileCv}
              onChange={(e) => onUseProfileCvChange(e.target.checked)}
              disabled={disabled}
            />
            Usar mi CV guardado
          </label>
        </div>
      ) : null}
      {showProfileSaveHint && !hasProfileCv ? (
        <p className={styles.profileSaveHint}>
          Si adjuntás un CV, lo guardamos en tu perfil para que puedas reutilizarlo en futuras
          postulaciones.
        </p>
      ) : null}
      <div className={styles.fileInputWrapper}>
        <input
          id={inputId}
          name={inputId}
          type="file"
          className={styles.fileInput}
          accept={ACCEPTED_CV_TYPES}
          onChange={handleFileChange}
          disabled={disabled}
        />
        <div className={styles.customFileInput}>
          <Upload size={18} />
          <span className={styles.fileName}>{cvFileName || filePlaceholder}</span>
        </div>
      </div>
    </>
  );
};

export default JobApplicationCvField;
